module.exports = __webpack_public_path__ + "img/finland-stomach-cancer-female.afec3b29.png";